<template>
  <v-navigation-drawer  class="navigator-section" :width="240">
    <v-list>
      <v-list-item>
        <img
          class="img-drawer"
          :src="require('@/assets/imgs/svgs/logo-white.svg')"
          alt="Commercia Logo">
      </v-list-item>

      <v-list-item
        @click="changeRoute('dashboard')"
        prepend-icon="mdi-view-dashboard-outline"
        :class="isActiveRoute('/dashboard')"
        title="Dashboard" link/>

      <v-list-item v-if="busines"
        @click="changeRoute('sales')"
        prepend-icon="mdi-cash-multiple"
        :class="isActiveRoute('/sales')"
        title="Ventas" link/>

      <v-list-item v-if="user?.role.name === 'master' && !busines"
        prepend-icon="mdi-briefcase-variant-outline"
        title="Negocios" link
        :class="isActiveRoute('/business')"
        @click="changeRoute('business')"/>

      <v-list-item v-if="busines && !(ifManager(user?.role.name) || ifFinance(user?.role.name))"
        prepend-icon="mdi-storefront-outline"
        title="POS" link color="#ffffff"
        :class="isActiveRoute('/pos')"
        @click="changeRoute('pos')"/>

      <v-list-item v-if="busines && !(ifManager(user?.role.name) || ifFinance(user?.role.name))"
        prepend-icon="mdi-briefcase-variant-outline"
        title="Colaboradores" link
        :class="isActiveRoute('/collaborators')"
        @click="changeRoute('collaborators')"/>

      <v-list-item v-if="busines && !ifFinance(user?.role.name) "
        prepend-icon="mdi-tag-multiple-outline"
        title="Categorías" link color="#ffffff"
        :class="isActiveRoute('/category')"
        @click="changeRoute('category')"/>

      <v-list-item v-if="busines && !ifFinance(user?.role.name)"
        prepend-icon="mdi-plus-box-outline"
        title="Extras" link color="#ffffff"
        :class="isActiveRoute('/extras')"
        @click="changeRoute('extras')"/>

      <v-list-item v-if="busines && !ifFinance(user?.role.name)"
        prepend-icon="mdi-cart-outline"
        title="Productos" link color="#ffffff"
        :class="isActiveRoute('/catalog')"
        @click="changeRoute('catalog')"/>

      <v-list-item v-if="busines && !ifFinance(user?.role.name)"
        prepend-icon="mdi-package-variant-closed"
        title="Almacén" link color="#ffffff"
        :class="isActiveRoute('/stock')"
        @click="changeRoute('stock')"/>

      <v-list-item v-if="busines && !ifFinance(user?.role.name)"
        prepend-icon="mdi-shopping-outline"
        title="Órdenes" link color="#ffffff"
        :class="isActiveRoute('/orders')"
        @click="changeRoute('orders')"/>

      <v-list-item v-if="busines && !ifFinance(user?.role.name)"
        prepend-icon="mdi-cash-sync"
        title="Cortes de caja" link color="#ffffff"
        :class="isActiveRoute('/cuts')"
        @click="changeRoute('cuts')"/>

      <!--
      <v-list-item prepend-icon="mdi-sign-caution"
        title="Actividad" link color="#ffffff"
        :class="isActiveRoute('/activity')"
        @click="changeRoute('activity')"/>
      -->
    </v-list>

    <template v-slot:append v-if="busines && user?.role.name === 'master'">
      <div  class="btn-logout" @click="logoutBusiness">
        <span>{{busines.name}}</span>
        <v-icon icon="mdi-logout"></v-icon>
      </div>
    </template>

  </v-navigation-drawer>
</template>
<script>
export default {
  name: 'CommerciaVueDrawer',
  data () {
    return {
      isGroupOpen: true
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    busines () {
      return this.$store.getters.business
    }
  },
  mounted () { },
  methods: {
    logoutBusiness () {
      this.$store.dispatch('clearBusiness')
    },
    ifManager (role) {
      return role === 'manager'
    },
    ifFinance (role) {
      return role === 'finance'
    },
    changeRoute (path) {
      this.$store.dispatch('savePath', path)
    },
    isActiveRoute (path) {
      return this.$route.path === path ? 'list-active' : ''
    }
  }
}
</script>
<style scoped>
.img-drawer{
  width: 161px;
  height: 28px;
  margin-top: 35px;
  margin-bottom: 35px;
  margin-left: 15px;
}
.navigator-section{
  background-color: #222222;
  color: #F9F6F2;
}
.list-active{
  background: #FFEADE ;
  color: #222222;
}
.btn-logout{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
  padding: 10px;
  color: #F9F6F2;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

.btn-logout:hover{
  background-color: #FFFFFF33;
}
</style>
